import styles from './Loader.module.css';

const Loader = ({ message = "Sending..." }) => {
    return (
        <div className={styles['loader-overlay']}>
            <div className={styles.spinner}></div>
            <p>{message}</p>
        </div>
    );
};

export default Loader;
